module.exports = __webpack_public_path__ + "@/assets/img/prices-icon.0e2e1999.svg";